import styled from 'styled-components';
export const ToolTipWrapper = styled.div`
  height: 220px;
  width: auto;
  position: ${props => props.style.position};
  left: ${props => props.style.left};
  top: ${props => props.style.top};
  z-index: ${props => props.style.zIndex};
`;
export const CloseIcon = styled.span`
  height: 25px;
  width: 20px;
  color: #e52000;
  float: right;
  margin-right: 2px;
  font-weight: bold;
  &:hover {
    cursor: pointer;
  }
`;
export const ToolTipContent = styled.div`
  border: 1px #d8d8d8 solid;
  border-radius: 10px;
  text-shadow: 10px;
  text-align: left;
  padding: 10px 20px;
  font-size: 13px;
  font-family: Arial, Helvetica, sans-serif;
  background-color: white;
  box-shadow: 3px 3px 3px 3px rgb(0 0 0 / 20%);
`;
export const ObjectKey = styled.div`
  font-weight: bold;
  font-family: Helvetica;
  text-decoration: underline;
`;